import RADApplication from '@/Management/RADApplication';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';

export default class RADEnvironmentProxyInterceptor {

    private static _args(keys, args) {
        const result = {token: RADApplication.getInstance().token};

        for (let i = 0; i < keys.length; i++) {
            result[keys[i]] = args[0][keys[i]];
        }

        return result;
    }

    public static intercept(originalProxy: RADEnvironmentProxy): void {
        const proto = Object.getPrototypeOf(originalProxy);
        const _orginalCallOperationFromDVContext = proto.callOperationFromDVContext.bind(originalProxy);

        proto.callOperationFromDVContext = (...allArguments: Array<any>) => {
            if (!allArguments[0].hasOwnProperty('withValidation')) {
                allArguments[0]['withValidation'] = true;
            }

            return _orginalCallOperationFromDVContext(allArguments[0]);

        };

        proto.constructor.outputMessage = (...allArguments: Array<any>) => {
            const args = RADEnvironmentProxyInterceptor._args(['message', 'priority'], allArguments);

            const deferred = $.ajax({
                url: MODEL.HTMLClientBaseURL + 'HTMLClient/Json/' + 'outputMessage',
                type: 'POST',
                headers: {'__RequestVerificationToken': RADApplication.getInstance().xcsrfToken},
                cache: false,
                async: true,
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(args)
            });

            return deferred;
        };
    }

}